import { Title, Text } from "@mantine/core";
import { useParams } from "react-router-dom";

export function PromptDetailPage() {
  const { promptId } = useParams();

  return (
    <>
      <Title order={2} mb="md">
        Prompt Detail
      </Title>
      <Text c="dimmed">Prompt ID: {promptId}</Text>
      <Text c="dimmed" mt="sm">
        This page will show the prompt editor, version history, and test runner.
      </Text>
    </>
  );
}
